import { useEffect, useState } from "react";
import { Image as ImageIcon } from "lucide-react";

export const ARTIST_IMAGE_FALLBACK = "artist_fallback";

export default function EventDisplayImage({
  src,
  alt,
  imageResolutionStatus,
  className = "",
  compactLabel = false,
}) {
  const [errored, setErrored] = useState(false);
  const usesArtistImage = imageResolutionStatus === ARTIST_IMAGE_FALLBACK;

  useEffect(() => {
    setErrored(false);
  }, [src]);

  return (
    <div className={`relative flex items-center justify-center overflow-hidden bg-muted ${className}`}>
      {src && !errored ? (
        <img
          src={src}
          alt={alt}
          className="h-full w-full object-cover"
          onError={() => setErrored(true)}
        />
      ) : (
        <ImageIcon className="h-8 w-8 text-muted-foreground" />
      )}
      {src && !errored && usesArtistImage && (
        <span
          className="absolute bottom-1.5 left-1.5 max-w-[calc(100%_-_0.75rem)] truncate rounded bg-emerald-700/90 px-1.5 py-0.5 text-[10px] font-semibold text-white shadow-sm"
          title="Artist image used on Applauss"
        >
          {compactLabel ? "Artist" : "Artist image used on Applauss"}
        </span>
      )}
    </div>
  );
}
